import { render, staticRenderFns } from "./requests-overview.vue?vue&type=template&id=cdc52ae4&"
import script from "./requests-overview.vue?vue&type=script&lang=js&"
export * from "./requests-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports